import { render } from "./DetailsHeader.vue?vue&type=template&id=7ff71eee&scoped=true"
import script from "./DetailsHeader.vue?vue&type=script&lang=js"
export * from "./DetailsHeader.vue?vue&type=script&lang=js"

import "./DetailsHeader.vue?vue&type=style&index=0&id=7ff71eee&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7ff71eee"

export default script